/**
 * Opis stanu z panelu produkcji p4umake w znacznikach (06.10.2026, właściciel: „dlaczego SellBase nie wyświetla
 * informacji, które wysyła panel produkcji?”). Panel wysyła drukarkę (`printer`, np. „A1-11” albo „A1-09 + A1-12”),
 * przewidywany koniec (`eta`), postęp i notatkę („Start 10:08 · A1-11 · 1xADP016_0.6_PLA.gcode.3mf (1 szt.)”) —
 * znacznik pokazywał zamiast tego „kto” („farma (agent)”). Moduł bez importów: używają go order-tags.ts (nagłówek
 * karty) i orders-shared.ts (znacznik przy produkcie).
 */

/** Godzina czasu polskiego z ISO („2026-10-06T11:29:00+00:00” → „13:29”); pusta przy braku/złej dacie. */
export function godzinaPL(iso: any): string {
  const t = new Date(String(iso || '')).getTime();
  if (!iso || !isFinite(t)) return '';
  return new Date(t).toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Warsaw' });
}

/** Postęp trwającego druku w %. 06.10.2026 (właściciel): „niech wyświetla też, ile procent druku ukończono”.
 * Postęp z panelu (`progress` > 0) — dokładny; panel na razie wysyła 0, więc wtedy szacunek z czasu startu
 * i przewidywanego końca, oznaczony „~” i najwyżej 99% (100% = dopiero status „wydrukowane”). */
export function postepDruku(z: any, teraz: number = Date.now()): { tekst: string; szacowany: boolean; wartosc: number | null } {
  const brak = { tekst: '', szacowany: false, wartosc: null };
  if (!z || String(z.status) !== 'printing') return brak;
  const p = Number(z.progress);
  if (z.progress != null && z.progress !== '' && isFinite(p) && p > 0) {
    const v = Math.max(0, Math.min(100, Math.round(p)));
    return { tekst: v + '%', szacowany: false, wartosc: v };
  }
  const od = new Date(String(z.since || '')).getTime();
  const doo = new Date(String(z.eta || '')).getTime();
  if (!z.since || !z.eta || !isFinite(od) || !isFinite(doo) || doo <= od) return brak;
  const v = Math.max(0, Math.min(99, Math.round((100 * (teraz - od)) / (doo - od))));
  return { tekst: '~' + v + '%', szacowany: true, wartosc: v };
}

/** Krótkie części znacznika druku: drukarka, postęp i „koniec HH:MM” (z eta, gdy druk trwa albo czeka). 06.10.2026
 * (właściciel): „niech wyświetla pełne info, tj. kiedy koniec druku” — wprost „koniec”, nie „do”. */
export function czesciDruku(z: any, teraz: number = Date.now()): { drukarka: string; postep: string; koniec: string } {
  const st = String((z && z.status) || '');
  const drukarka = String((z && z.printer) || '').trim();
  const godz = z && z.eta && (st === 'printing' || st === 'queued') ? godzinaPL(z.eta) : '';
  return { drukarka, postep: postepDruku(z, teraz).tekst, koniec: godz ? 'koniec ' + godz : '' };
}

/** Linie podpowiedzi (title): drukarka, start/koniec/postęp, notatka panelu i „kto”. */
export function szczegolyProdukcji(z: any): string[] {
  if (!z) return [];
  const linie: string[] = [];
  if (z.printer) linie.push('Drukarka: ' + String(z.printer));
  const czasy: string[] = [];
  const start = godzinaPL(z.since);
  const koniec = godzinaPL(z.eta);
  if (start) czasy.push('od ' + start);
  if (koniec) czasy.push('koniec ok. ' + koniec);
  const postep = postepDruku(z);
  if (postep.tekst) czasy.push('postęp ' + postep.tekst + (postep.szacowany ? ' (szacunek z czasu startu i końca)' : ' (z panelu)'));
  if (czasy.length) linie.push(czasy.join(' · '));
  if (z.note) linie.push('Panel: ' + String(z.note));
  if (z.worker) linie.push('Zgłasza: ' + String(z.worker));
  return linie;
}
